@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.far.suller.pages.homePage as _com_far_suller_pages_homePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Farsuller"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_far_suller_pages_homePage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("header-container", com.far.suller.components.HeaderContainerStyle)
        ctx.theme.registerStyle("scrolled-header", com.far.suller.components.ScrolledHeaderStyle)
        ctx.theme.registerStyle("about-image", com.far.suller.styles.AboutImageStyle)
        ctx.theme.registerStyle("about-text", com.far.suller.styles.AboutTextStyle)
        ctx.theme.registerStyle("back-to-top-button", com.far.suller.styles.BackToTopButtonStyle)
        ctx.theme.registerStyle("input", com.far.suller.styles.InputStyle)
        ctx.theme.registerStyle("navigation-item", com.far.suller.styles.NavigationItemStyle)
        ctx.theme.registerStyle("logo", com.far.suller.styles.LogoStyle)
        ctx.theme.registerStyle("social-links", com.far.suller.styles.SocialLinksStyle)
        ctx.theme.registerStyle("main-button", com.far.suller.styles.MainButtonStyle)
        ctx.theme.registerStyle("main-image", com.far.suller.styles.MainImageStyle)
        ctx.theme.registerStyle("portfolio-section", com.far.suller.styles.PortfolioSectionStyle)
        ctx.theme.registerStyle("portfolio-arrow-icon", com.far.suller.styles.PortfolioArrowIconStyle)
        ctx.theme.registerStyle("service-section", com.far.suller.styles.ServiceSectionStyle)
        ctx.theme.registerKeyframes("code-window-blink", com.far.suller.components.CodeWindowBlinkKeyframes)
        ctx.theme.registerKeyframes("node-pulse", com.far.suller.components.NodePulseKeyframes)
        ctx.theme.registerKeyframes("cursor-blink", com.far.suller.components.CursorBlinkKeyframes)
        ctx.theme.registerKeyframes("train-travel", com.far.suller.components.TrainTravelKeyframes)
        ctx.theme.registerKeyframes("skill-glow", com.far.suller.components.SkillGlowKeyframes)
        ctx.theme.registerKeyframes("pill-slide-in", com.far.suller.components.PillSlideInKeyframes)
        ctx.theme.registerKeyframes("marquee", com.far.suller.sections.MarqueeKeyframes)
        ctx.theme.registerKeyframes("testimonial-marquee-left", com.far.suller.sections.TestimonialMarqueeLeft)
        ctx.theme.registerKeyframes("testimonial-marquee-right", com.far.suller.sections.TestimonialMarqueeRight)
        com.far.suller.updateTheme(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.far.suller.myApp {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
